import { render, staticRenderFns } from "./JsonFeedback.vue?vue&type=template&id=a30d1d42&"
import script from "./JsonFeedback.vue?vue&type=script&lang=ts&"
export * from "./JsonFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./JsonFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
